export default ['😊', '😍', '🙂', '🙃', '😀', '😄'];